// extracted by mini-css-extract-plugin
export default {"kTextbox":"AgriculturalUseCategoriesOfLandTable_kTextbox__22bTU","GreyedOut":"AgriculturalUseCategoriesOfLandTable_GreyedOut__3GhtN"};